<template>
    <DCard
        padding
    >
        <Form
            :whmcs-settings="whmcsSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
</template>

<script>
import Form from '~@/Components/Settings/WhmcsSettings/Form'

export default {
    name: 'WhmcsSettingsCreate',
    components: {
        Form
    },
    props: {
        whmcsSettings: {
            type: Object,
            default () {
                return {}
            }
        },
        errors: {
            type: Object,
            default () {
                return {}
            }
        }
    },
    methods: {
        submitData (form) {
            form.post(this.$route('settings.whmcs-settings.store'))
        }
    }
}
</script>
